import { render, staticRenderFns } from "./Get.vue?vue&type=template&id=53c1a082&scoped=true&"
import script from "./Get.vue?vue&type=script&lang=js&"
export * from "./Get.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c1a082",
  null
  
)

export default component.exports